import type { OrderDetailsExtended } from 'app/src/model'
import { apiBaseUrl } from 'app/src/msw/shopping/staticapi/apiBaseUrl'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { DateTime } from 'luxon'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getOrders = http.get<object, DefaultBodyType, shoppingApi.OrderPaginated>(
  apiBaseUrl + '/orders',
  async ({ request }) => {
    const url = new URL(request.url)
    const status = url.searchParams.get('status')
    const discount = url.searchParams.get('typology') === 'discount'
    const additionalInfoPrize = url.searchParams.get('additionalInfoPrize')
    const additionalInfoVirtualMoney = url.searchParams.get('additionalInfoVirtualMoney')
    const membershipId = url.searchParams.get('membershipId')

    const sort = url.searchParams.get('sort')
    const from = url.searchParams.get('from')
    const to = url.searchParams.get('to')

    const offset = url.searchParams.get('pagingOffset')
    const limit = url.searchParams.get('pagingLimit')

    const discountOrdersCollection = await (await fetch('./data/shopping/discountOrders.json')).json()
    const giftCardsOrdersCollection = await (await fetch('./data/shopping/giftCardsOrders.json')).json()
    const goodAndServiceOrdersCollection = await (await fetch('./data/shopping/goodAndServiceOrders.json')).json()
    const vouchersOrdersCollection = await (await fetch('./data/shopping/vouchersOrders.json')).json()
    // const parentOrderId = url.searchParams.get('parentOrderId')

    let items: shoppingApi.OrderListItem[] = []
    if (discount)
      items = (discountOrdersCollection?.items || [])
        .filter((order: OrderDetailsExtended) => order?.userInfo?.membershipId === membershipId)
        .map((order: OrderDetailsExtended) => ({
          orderId: order.orderId,
          orderDate: order.orderDate,
          priceDetails: order.priceDetails,
          productName: order.product.productName,
          productTypology: order.product.typology,
          status: order.status,
          detailPageUrl: order.detailPageUrl,
          purchaseDetails: order.purchaseDetails,
        }))
    else {
      items = (giftCardsOrdersCollection?.items || [])
        .filter((order: OrderDetailsExtended) => order?.userInfo?.membershipId === membershipId)
        .map((order: OrderDetailsExtended) => ({
          orderId: order.orderId,
          orderDate: order.orderDate,
          priceDetails: order.priceDetails,
          productName: order.product.productName,
          productTypology: order.product.typology,
          status: order.status,
          detailPageUrl: order.detailPageUrl,
          purchaseDetails: order.purchaseDetails,
        }))
        .concat(
          (goodAndServiceOrdersCollection?.items || [])
            .filter((order: OrderDetailsExtended) => order?.userInfo?.membershipId === membershipId)
            .map((order: OrderDetailsExtended) => ({
              orderId: order.orderId,
              orderDate: order.orderDate,
              priceDetails: order.priceDetails,
              productName: order.product.productName,
              productTypology: order.product.typology,
              status: order.status,
              detailPageUrl: order.detailPageUrl,
              purchaseDetails: order.purchaseDetails,
            })),
        )
        .concat(
          (vouchersOrdersCollection?.items || [])
            .filter((order: OrderDetailsExtended) => order?.userInfo?.membershipId === membershipId)
            .map((order: OrderDetailsExtended) => ({
              orderId: order.orderId,
              orderDate: order.orderDate,
              priceDetails: order.priceDetails,
              productName: order.product.productName,
              productTypology: order.product.typology,
              status: order.status,
              detailPageUrl: order.detailPageUrl,
              purchaseDetails: order.purchaseDetails,
            })),
        )
    }

    if (sort == '+date') {
      items = items.sort((a, b) => DateTime.fromISO(a.orderDate).toMillis() - DateTime.fromISO(b.orderDate).toMillis())
    }

    if (sort == '-date') {
      items = items.sort((a, b) => DateTime.fromISO(b.orderDate).toMillis() - DateTime.fromISO(a.orderDate).toMillis())
    }

    if (status !== null) {
      items = items.filter((item) => status?.split(',').includes(item.status))
    }

    let fromDate = undefined
    let toDate = undefined
    if (from !== null) {
      fromDate = DateTime.fromISO(from).toMillis()
    }
    if (to !== null) {
      toDate = DateTime.fromISO(to).toMillis()
    }

    items = items.filter((item) => {
      const orderDate = DateTime.fromISO(item.orderDate)

      if (fromDate && toDate) {
        return orderDate.toMillis() >= fromDate && orderDate.toMillis() <= toDate
      } else if (fromDate) {
        return orderDate.toMillis() >= fromDate
      } else if (toDate) {
        return orderDate.toMillis() <= toDate
      } else {
        return true
      }
    })

    const totItems = items.length

    const offsetInt = offset !== null ? parseInt(offset, 10) : 0
    const limitInt = limit !== null ? parseInt(limit, 10) : 5

    items = items.slice(offsetInt, offsetInt + limitInt)

    let orderListResponse: shoppingApi.OrderPaginated = {
      paging: {
        limit: limitInt,
        offset: offsetInt,
        total: totItems,
      },
      items: items,
    }

    if (additionalInfoPrize == 'true') {
      orderListResponse = {
        paging: {
          limit: 1,
          offset: 0,
          total: 1,
        },
        items: [
          // {
          //   detailPageUrl: 'http://localhost:3001/#/shop/direct/goodandservice/GOODANDSERVICE.DRAFT.CONFIRMED',
          //   orderDate: '2024-08-09T09:18:38.029864Z',
          //   orderId: '55b9a9d5-6fb3-4cdf-af30-709b5b5aeb9a',
          //   priceDetails: {
          //     grossPrice: 0,
          //     netPrice: 0,
          //     taxAmount: 0,
          //     taxClass: 'IVA4',
          //     taxPercentage: 0
          //   },
          //   productName: 'Consulto in televisita e primo inquadramento con un medico di base',
          //   productTypology: 'goodAndService',
          //   status: 'confirmed' //confirmed //used
          // }
        ],
      }
    }

    if (additionalInfoVirtualMoney === 'true') {
      orderListResponse = {
        paging: {
          limit: limitInt,
          offset: 0,
          total: 20,
        },
        items: [
          {
            detailPageUrl:
              'https://posteitaliane.sharepoint.com/sites/PosteMondoWelfare-Sviluppo/SitePages/Voucher.aspx?orderId=9395ad6a-db21-43b7-8a0c-c77fb99e15ff',
            orderDate: '2024-08-09T09:19:33.53095Z',
            orderId: '9395ad6a-db21-43b7-8a0c-c77fb99e15ff',
            priceDetails: {
              grossPrice: 100,
              netPrice: 100,
              taxAmount: 0,
              taxClass: 'FCI',
              taxPercentage: 0,
            },
            productName: 'Emissione Voucher PosteWelfare',
            productTypology: 'voucher',
            status: 'confirmed',
          },
          {
            detailPageUrl:
              'https://posteitaliane.sharepoint.com/sites/PosteMondoWelfare-Sviluppo/SitePages/Voucher.aspx?orderId=9395ad6a-db21-43b7-8a0c-c77fb99e15ff',
            orderDate: '2024-08-09T09:19:33.53095Z',
            orderId: '9395ad6a-db21-43b7-8a0c-c77fb99e15ff',
            priceDetails: {
              grossPrice: 20,
              netPrice: 20,
              taxAmount: 0,
              taxClass: 'FCI',
              taxPercentage: 0,
            },
            productName: 'Emissione Voucher PosteWelfare',
            productTypology: 'voucher',
            status: 'confirmed',
          },
          {
            detailPageUrl:
              'https://posteitaliane.sharepoint.com/sites/PosteMondoWelfare-Sviluppo/SitePages/Voucher.aspx?orderId=fb431079-45e5-400d-adc8-827323479065',
            orderDate: '2024-08-09T09:19:33.517567Z',
            orderId: 'fb431079-45e5-400d-adc8-827323479065',
            priceDetails: {
              grossPrice: 20,
              netPrice: 20,
              taxAmount: 0,
              taxClass: 'FCI',
              taxPercentage: 0,
            },
            productName: 'Emissione Voucher PosteWelfare',
            productTypology: 'voucher',
            status: 'confirmed',
          },
          {
            detailPageUrl:
              'https://posteitaliane.sharepoint.com/sites/PosteMondoWelfare-Sviluppo/SitePages/Voucher.aspx?orderId=a14b1a4a-c156-4447-abd1-a9ce35d2e8f7',
            orderDate: '2024-08-09T09:19:33.505533Z',
            orderId: 'a14b1a4a-c156-4447-abd1-a9ce35d2e8f7',
            priceDetails: {
              grossPrice: 20,
              netPrice: 20,
              taxAmount: 0,
              taxClass: 'FCI',
              taxPercentage: 0,
            },
            productName: 'Emissione Voucher PosteWelfare',
            productTypology: 'voucher',
            status: 'confirmed',
          },
          {
            detailPageUrl:
              'https://posteitaliane.sharepoint.com/sites/PosteMondoWelfare-Sviluppo/SitePages/Voucher.aspx?orderId=757ce511-74f8-4645-ad31-809073ea1a62',
            orderDate: '2024-07-18T09:20:04.478145Z',
            orderId: '757ce511-74f8-4645-ad31-809073ea1a62',
            priceDetails: {
              grossPrice: 50,
              netPrice: 50,
              taxAmount: 0,
              taxClass: 'FCI',
              taxPercentage: 0,
            },
            productName: 'Emissione Voucher PosteWelfare',
            productTypology: 'voucher',
            status: 'used',
          },
          {
            detailPageUrl:
              'https://posteitaliane.sharepoint.com/sites/PosteMondoWelfare-Sviluppo/SitePages/Voucher.aspx?orderId=f8b90f78-e8e4-483c-8ae7-3493f8947922',
            orderDate: '2024-07-18T09:20:04.464236Z',
            orderId: 'f8b90f78-e8e4-483c-8ae7-3493f8947922',
            priceDetails: {
              grossPrice: 50,
              netPrice: 50,
              taxAmount: 0,
              taxClass: 'FCI',
              taxPercentage: 0,
            },
            productName: 'Emissione Voucher PosteWelfare',
            productTypology: 'voucher',
            status: 'confirmed',
          },
        ],
      }
    }

    return HttpResponse.json(orderListResponse)
  },
)
